export const trainingCategories = [
  {
    id: 1,
    title: 'Quality Management Training',
    description: 'ISO certification training and auditing courses for effective Quality Management Systems',
    icon: 'award',
    courses: ['ISO 9001 Internal Auditor', 'ISO 9001 Lead Auditor', 'ISO 14001 Training', 'ISO 45001 Training']
  },
  {
    id: 2,
    title: 'Leadership & Management Skills',
    description: 'Develop leadership capabilities and management excellence for organizational success',
    icon: 'users',
    courses: ['Strategic Leadership', 'Team Management', 'Decision Making', 'Change Management']
  },
  {
    id: 3,
    title: 'Communication Skills',
    description: 'Enhance professional communication for effective workplace interactions',
    icon: 'message-circle',
    courses: ['Business Communication', 'Presentation Skills', 'Negotiation Skills', 'Conflict Resolution']
  },
  {
    id: 4,
    title: 'Soft Skills Training',
    description: 'Build essential interpersonal skills for career growth and professional development',
    icon: 'trending-up',
    courses: ['Time Management', 'Problem Solving', 'Emotional Intelligence', 'Critical Thinking']
  },
  {
    id: 5,
    title: 'Faculty Development Programs',
    description: 'Specialized programs for educational institutions to enhance teaching methodologies',
    icon: 'graduation-cap',
    courses: ['Pedagogy Excellence', 'Curriculum Design', 'Assessment Techniques', 'Digital Teaching']
  },
  {
    id: 6,
    title: 'Industry-Specific Training',
    description: 'Customized training solutions for Manufacturing, IT, and Educational sectors',
    icon: 'briefcase',
    courses: ['Manufacturing Excellence', 'IT Service Management', 'Quality Assurance', 'Process Optimization']
  }
];

export const statistics = [
  { id: 1, value: 1000, label: 'People Benefitted', suffix: '+' },
  { id: 2, value: 500, label: 'Certificates Issued', suffix: '+' },
  { id: 3, value: 10, label: 'Years of Experience', suffix: '+' },
  { id: 4, value: 50, label: 'Training Programs', suffix: '+' }
];

export const whyChooseUs = [
  {
    id: 1,
    title: 'Expert Instructors',
    description: 'Our instructors are well-respected specialists with both theoretical and practical experience in their fields',
    icon: 'user-check'
  },
  {
    id: 2,
    title: 'Training Outcome',
    description: 'Run more effective management systems with improved quality, efficiency, and customer satisfaction',
    icon: 'target'
  },
  {
    id: 3,
    title: 'Flexible Delivery',
    description: 'Multiple modalities - Classroom, On-Site, and Online training to fit your schedule',
    icon: 'calendar'
  },
  {
    id: 4,
    title: 'Interactive Approach',
    description: 'Engaging courses with real-life situations and practical applications for your organization',
    icon: 'zap'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Rajesh Kumar',
    role: 'Quality Manager, Manufacturing Co.',
    content: 'The ISO 9001 training was exceptional. Our team gained practical insights that we implemented immediately. Highly recommended!',
    rating: 5,
    company: 'Leading Manufacturing Firm'
  },
  {
    id: 2,
    name: 'Dr. Priya Sharma',
    role: 'Dean, Engineering College',
    content: 'ISDE Academy transformed our faculty development program. The training methodology is world-class.',
    rating: 5,
    company: 'Top Engineering Institute'
  },
  {
    id: 3,
    name: 'Amit Patel',
    role: 'IT Director',
    content: 'Best soft skills training we have invested in. The ROI has been remarkable with improved team collaboration.',
    rating: 5,
    company: 'IT Services Company'
  },
  {
    id: 4,
    name: 'Sunita Reddy',
    role: 'HR Head',
    content: 'The leadership training program helped our managers excel. Practical, engaging, and results-driven.',
    rating: 5,
    company: 'Corporate Enterprise'
  }
];

export const upcomingTrainings = [
  {
    id: 1,
    title: 'ISO 9001:2015 Internal Quality Auditor',
    date: '2025-02-15',
    duration: '2 Days',
    mode: 'Classroom',
    location: 'Chennai',
    seats: 15,
    price: '₹12,000'
  },
  {
    id: 2,
    title: 'Leadership Excellence Program',
    date: '2025-02-20',
    duration: '3 Days',
    mode: 'Online',
    location: 'Virtual',
    seats: 25,
    price: '₹15,000'
  },
  {
    id: 3,
    title: 'ISO 45001 Lead Auditor Training',
    date: '2025-02-25',
    duration: '5 Days',
    mode: 'Classroom',
    location: 'Bangalore',
    seats: 12,
    price: '₹25,000'
  },
  {
    id: 4,
    title: 'Effective Communication Skills',
    date: '2025-03-01',
    duration: '2 Days',
    mode: 'Hybrid',
    location: 'Chennai/Online',
    seats: 20,
    price: '₹10,000'
  },
  {
    id: 5,
    title: 'Faculty Development Program',
    date: '2025-03-10',
    duration: '3 Days',
    mode: 'On-Site',
    location: 'Customizable',
    seats: 30,
    price: 'Contact Us'
  },
  {
    id: 6,
    title: 'ISO 21001 Awareness Training',
    date: '2025-03-15',
    duration: '1 Day',
    mode: 'Online',
    location: 'Virtual',
    seats: 40,
    price: '₹6,000'
  }
];

export const successStories = [
  {
    id: 1,
    organization: 'Leading Manufacturing Company',
    training: 'ISO 9001 IQA and Awareness Training',
    participants: 45,
    outcome: 'Achieved ISO 9001 certification within 6 months'
  },
  {
    id: 2,
    organization: 'Top Engineering College',
    training: 'Faculty Development Program',
    participants: 60,
    outcome: 'Enhanced teaching methodologies and academic excellence by 40%'
  },
  {
    id: 3,
    organization: 'IT Services Provider',
    training: 'Leadership & Soft Skills Training',
    participants: 35,
    outcome: 'Improved team productivity by 35% and reduced attrition by 20%'
  }
];

export const partners = [
  { id: 1, name: 'Manufacturing Excellence Council' },
  { id: 2, name: 'IT Industry Association' },
  { id: 3, name: 'Educational Institutions Network' },
  { id: 4, name: 'Quality Management Forum' }
];
